import * as React from 'react';

import dayjs from 'dayjs';

import DatePicker, { DatePickerProps } from 'antd/lib/date-picker';

import { getPopupContainer } from '@common/react/components/Utils/Utils';

const disabledAfterToday = (currentDate?: dayjs.Dayjs) => (currentDate
	? currentDate.isBefore('0001-01-01') || currentDate.isAfter(dayjs(), 'day')
	: false);

const disabledBeforeToday = (currentDate?: dayjs.Dayjs) => (currentDate
	? currentDate.isBefore(dayjs(), 'day') || currentDate.isAfter('9999-12-31 23:59:59')
	: false);

interface ComponentProps {
	format?: string;
	placeholderRange?: [string, string];
	disabledDate?: (currentDate?: dayjs.Dayjs) => boolean;
	maxDateToday?: boolean;
	minDateToday?: boolean;
	locale?: any;
	dateRender?: (current: dayjs.Dayjs, today: dayjs.Dayjs) => React.ReactNode;
	utc?: boolean;
}

export interface DatepickerProps extends ComponentProps {
	value: number | null;
	onChange: (date: number | null) => void;
	antdProps?: DatePickerProps & {showTime?: boolean};
}

const Datepicker: React.FC<DatepickerProps> = ({
	value, onChange, format = 'MM/DD/YYYY', maxDateToday, minDateToday, disabledDate, locale, antdProps = {}, dateRender, utc,
}) => {
	// tslint:disable-next-line:no-parameter-reassignment
	if (maxDateToday) disabledDate = disabledAfterToday;

	// tslint:disable-next-line:no-parameter-reassignment
	if (minDateToday) disabledDate = disabledBeforeToday;

	const defaultValue = value !== null && value !== undefined ? utc ? dayjs(value).utc() : dayjs(value) : undefined;

	const innerOnChange = (date: dayjs.Dayjs | null) => {
		onChange(date === null ? null : +date);
	};

	return <div className="datepicker-component">
		<DatePicker
			{...antdProps}
			format={antdProps && antdProps.showTime ? 'MM/DD/YYYY HH:mm' : format}
			onChange={innerOnChange}
			disabledDate={disabledDate}
			locale={locale}
			value={defaultValue}
			getPopupContainer={antdProps?.getPopupContainer || getPopupContainer}
			dateRender={dateRender}
		/>
	</div>;
};

export default Datepicker;
